export default __webpack_public_path__ + "ed60d8e68da76a6eb1859759cab24c5a.pdf";